import { render, staticRenderFns } from "./PrevisaoFaturamento.vue?vue&type=template&id=b3ecc8da&"
import script from "./PrevisaoFaturamento.vue?vue&type=script&lang=js&"
export * from "./PrevisaoFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./PrevisaoFaturamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports